import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import CalendarRangePicker from "shared-components/CalendarRangePicker/CalendarRangePicker"
import moment from "moment"
import { Button, Icon, Input, Modal, Pagination, Popover, Select, Table } from "antd"
import { isArray } from "lodash"
import ModalResponsiveForTables from "shared-components/ModalResponsiveForTables/ModalResponsiveForTables"
import ModalRow from "shared-components/ModalResponsiveForTables/ModalRow"
import { numberWithCommas } from "utils/HelperFunc"
import { format } from "date-fns"
import { CSVLink } from "react-csv"
import ReactToPrint from "react-to-print"
import * as AuthRequest from "services/auth"

const { Option } = Select
const { confirm } = Modal

const NewDepositiAdmin = (props) => {
  const {
    getRequestedRefills,
    accountInfo,
    activeSkinId,
    loadingPayments,
    screenWidth,
    refills,
    refillsPages,
    fromDate,
    MessaggiComponent,
    forAdmin,
    requireRefillStatus,
    getTransferDocument,
    transferDocument,
  } = props

  const today = new Date()
  const todayApi = format(today, "yyyy-MM-dd")
  const todayLabel = format(today, "dd/MM/yyyy")

  const [from, setFrom] = useState(todayApi)
  const [to, setTo] = useState(todayApi)
  const [fromLabel, setFromLabel] = useState(todayLabel)
  const [toLabel, setToLabel] = useState(todayLabel)
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)
  const [perPage, setPerPage] = useState(25)
  const [showModalResponsive, setShowModalResponsive] = useState(false)
  const [modalDetails, setModalDetails] = useState("")
  const [filterName, setFilterName] = useState("")
  const [imageVisible, setImageVisible] = useState(false)
  const [paymentMethod, setPaymentMethod] = useState("")
  const [picker, setPicker] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
      color: "var(--accent-bg)",
    },
  ])

  const [isCsvLoading, setIsCsvLoading] = useState(false)
  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [exportData, setExportData] = useState([])
  const csvLinkRef = useRef()
  const componentRef = useRef()

  const csvHeaders = [
    { label: "Eseguito il", key: "eseguito_il" },
    { label: "Barcode", key: "barcode" },
    { label: "Mittente", key: "mittente" },
    { label: "Destinatario", key: "destinatario" },
    { label: "Tipo", key: "tipo_deposito" },
    { label: "Metodo", key: "metodo" },
    { label: "Importo", key: "amount" },
    { label: "Bank", key: "bank" },
    { label: "Stato", key: "stato" },
  ]
  const isCard =
    paymentMethod === "card" ? true : paymentMethod === "wallet" ? false : null

  const setCalendar = (val) => {
    setIsCalendarOpen(val)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    props.getRequestedRefills(
      1,
      perPage,
      accountInfo?.profile?.role?.name === "super_admin"
        ? accountInfo.profile.activity_id
        : activeSkinId !== -1
          ? activeSkinId
          : null,
      from,
      to,
      filterName,
      isCard,
    )
  }

  const handleTableChange = (pagination, filters) => {
    const value = filters.amount?.[0] || ""
    const isCard = value === "card" ? true : value === "wallet" ? false : null
    console.log(value)
    setPaymentMethod(value)
    props.getRequestedRefills(
      1,
      perPage,
      accountInfo?.profile?.role?.name === "super_admin"
        ? accountInfo.profile.activity_id
        : activeSkinId !== -1
          ? activeSkinId
          : null,
      from,
      to,
      filterName,
      isCard,
    )
  }

  const showConfirmAccept = (id) => {
    confirm({
      title: "Pagamento ricevuto! Accetta e ricarica il conto.",
      cancelText: "Cancella",
      onOk() {
        requireRefillStatus(id, "accepted")
      },
      onCancel() {
        props.getRequestedRefills(
          1,
          perPage,
          accountInfo?.profile?.role?.name === "super_admin"
            ? accountInfo.profile.activity_id
            : activeSkinId !== -1
              ? activeSkinId
              : null,
          from,
          to,
          filterName,
          isCard,
        )
      },
    })
  }

  const showConfirmDecline = (id) => {
    confirm({
      title: "Vuoi annullare questa richiesta di ricarica conto?",
      cancelText: "Cancella",
      onOk() {
        requireRefillStatus(id, "rejected")
      },
      onCancel() {
        props.getRequestedRefills(
          1,
          perPage,
          accountInfo?.profile?.role?.name === "super_admin"
            ? accountInfo.profile.activity_id
            : activeSkinId !== -1
              ? activeSkinId
              : null,
          from,
          to,
          filterName,
          isCard,
        )
      },
    })
  }

  useEffect(() => {
    getRequestedRefills(
      1,
      perPage,
      accountInfo?.profile?.role?.name === "super_admin"
        ? accountInfo.profile.activity_id
        : activeSkinId != -1
          ? activeSkinId
          : null,
      from || "",
      to || "",
      filterName,
      isCard,
    )
  }, [activeSkinId, fromDate])

  useEffect(() => {
    if (filterName.length >= 2 || filterName.length === 0) {
      const handler = setTimeout(() => {
        props.getRequestedRefills(
          1,
          perPage,
          accountInfo?.profile?.role?.name === "super_admin"
            ? accountInfo.profile.activity_id
            : activeSkinId !== -1
              ? activeSkinId
              : null,
          from,
          to,
          filterName,
          isCard,
        )
      }, 400)

      return () => clearTimeout(handler)
    }
  }, [filterName])

  const getFullData = async (setLoading) => {
    setLoading(true)
    try {
      const response = await AuthRequest.fetchRequestedRefills(
        1,
        10000,
        accountInfo?.profile?.role?.name === "super_admin"
          ? accountInfo.profile.activity_id
          : activeSkinId != -1
            ? activeSkinId
            : null,
        from,
        to,
        filterName,
        isCard,
      )

      const rawRefills = response?.data?.data?.refills || []

      const formattedData = rawRefills.map((item) => ({
        ...item,
        eseguito_il: `\t${moment(item.eseguito_il).format("DD/MM/YY HH:mm:ss")}`,
        barcode: item.id,
        tipo_deposito:
          item.paid_with_adyen === true
            ? "Card"
            : item.cgn
              ? "Bonifico Bancario"
              : "Wallet",
        amount: `\t${numberWithCommas(item.amount)}€`,
        mittente: item.mittente || "-",
        destinatario: item.destinatario || "-",
        metodo: item.metodo || "-",
        bank: item.cgn_bank_name || "-",
        stato: item.stato || "-",
      }))

      setExportData(formattedData)
      setLoading(false)
      return formattedData
    } catch (error) {
      console.error("Export error:", error)
      setLoading(false)
      return []
    }
  }

  const resetDates = () => {
    setFrom(todayApi)
    setTo(todayApi)

    setFromLabel(todayLabel)
    setToLabel(todayLabel)
  }

  const columns =
    screenWidth > 1024
      ? [
          {
            title: "Eseguito il",
            dataIndex: "eseguito_il",
            key: "eseguito_il",
            ellipsis: true,
            width: "12%",
            render: (text) => moment(text).format("DD/MM/YY HH:mm:ss"),
          },
          {
            title: "Barcode",
            dataIndex: "id",
            key: "id",
            ellipsis: true,
            width: "12%",
            align: "center",
          },
          {
            title: "DAL",
            dataIndex: "mittente",
            key: "mittente",
            ellipsis: true,
            width: "12%",
            align: "center",
          },
          {
            title: "",
            dataIndex: "",
            key: "",
            width: "5%",
            ellipsis: true,
            align: "center",
            render: (text, record) =>
              record.metodo === "Deposito" ||
              record.metodo === "Bonifico Bancario" ? (
                <i className="fal fa-arrow-right" style={{ fontSize: 18 }}></i>
              ) : (
                <i className="fal fa-arrow-left" style={{ fontSize: 18 }}></i>
              ),
          },
          {
            title: "AL",
            dataIndex: "destinatario",
            key: "destinatario",
            width: "10%",
            ellipsis: true,
            onCell: (record) => ({
              onClick: () => {
                console.log(record)
                setFilterName(record.destinatario)
                // getRequestedRefills(
                //   1,
                //   perPage,
                //   accountInfo?.profile?.role?.name === "super_admin"
                //     ? accountInfo.profile.activity_id
                //     : activeSkinId !== -1
                //       ? activeSkinId
                //       : null,
                //   from,
                //   to,
                //   record.destinatario,
                //   isCard,
                // )
              },
            }),
          },
          {
            title: "Metodo",
            dataIndex: "metodo",
            key: "metodo",
            width: "10%",
            ellipsis: true,
            align: "center",
          },
          {
            title: "Importo",
            dataIndex: "amount",
            key: "amount",
            align: "center",
            width: "14%",
            ellipsis: true,
            filters: [
              { text: "Card", value: "card" },
              { text: "Wallet", value: "wallet" },
            ],
            filteredValue: paymentMethod ? [paymentMethod] : null,

            render: (text, record) => {
              const isPositive =
                record.metodo === "Deposito" || record.metodo === "Bonifico Bancario"

              const iconClass = isPositive ? "fa-plus-circle" : "fa-minus-circle"
              const iconColor = isPositive ? "#0DA90F" : "#FF0000"

              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    maxWidth: 120,
                    margin: "0 auto",
                  }}
                >
                  <i
                    className={`fal ${iconClass} fa-sm`}
                    style={{ color: iconColor }}
                  ></i>

                  <span>{text}€</span>

                  {record.paid_with_adyen ? (
                    <i
                      className="fa-solid fa-credit-card"
                      style={{ fontSize: 18, color: "rgb(96 165 250)" }}
                    ></i>
                  ) : record.cgn && !record.bank ? (
                    <span
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        backgroundColor: "#1958A0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      €
                    </span>
                  ) : (
                    <i
                      className="fa-solid fa-money-bill-wave"
                      style={{ fontSize: 18, color: "green" }}
                    ></i>
                  )}
                </div>
              )
            },
          },
          {
            title: "Commisione",
            dataIndex: "commissione",
            key: "commissione",
            align: "right",
            width: "10%",
            ellipsis: true,
            render: (text) => <span>{text.toFixed(2)}€</span>,
          },
          {
            title: "Bank",
            dataIndex: "bank",
            key: "bank",
            align: "center",
            width: "10%",
            ellipsis: true,
            render: (text, record) => record.bank ?? "-",
          },
          // {
          //   title: "Ricevuta",
          //   dataIndex: "document",
          //   key: "document",
          //   width: "10%",
          //   align: "center",
          //   ellipsis: true,
          //   render: (text, record) =>
          //     record.document ? (
          //       <a
          //         onClick={() => {
          //           getTransferDocument(record.id)
          //           setImageVisible(true)
          //         }}
          //         style={{ textDecoration: "underline" }}
          //       >
          //         Apri l'allegato
          //       </a>
          //     ) : (
          //       "Non prevenuto"
          //     ),
          // },
          {
            title: "Stato",
            dataIndex: "stato",
            key: "stato",
            width: "12%",
            ellipsis: true,
            align: "center",
            filters: [
              { text: "Pending", value: "pending" },
              { text: "Accettato", value: "accepted" },
              { text: "Rifiutato", value: "rejected" },
            ],
            onFilter: (value, record) => record.stato === value,
            render: (text, record) => {
              const role = accountInfo?.profile?.role?.name

              if (
                (role === "super_admin" || role === "main_admin") &&
                text === "pending"
              ) {
                return (
                  <div className="accept-refills">
                    <Select
                      placeholder="Pending"
                      style={{ width: 100 }}
                      onChange={(value) => {
                        if (value === "accept") {
                          showConfirmAccept(record.id)
                        } else {
                          showConfirmDecline(record.id)
                        }
                      }}
                    >
                      <Option value="accept">Accettato</Option>
                      <Option value="reject">Annulla</Option>
                    </Select>
                  </div>
                )
              }

              if (text === "accepted") {
                return forAdmin ? (
                  <Icon
                    style={{ fontSize: "large", color: "#0da90f" }}
                    type="check-circle"
                  />
                ) : (
                  "Accettato"
                )
              }

              if (text === "rejected") {
                return forAdmin ? (
                  <Icon
                    style={{ fontSize: "large", color: "#ff0000" }}
                    type="close-circle"
                  />
                ) : (
                  "Rifiutato"
                )
              }

              return "Pending"
            },
            // text === "accepted" ? (
            //   <Icon
            //     style={{ fontSize: "large", color: "#0da90f" }}
            //     type="check-circle"
            //   />
            // ) : text === "rejected" ? (
            //   <Icon
            //     style={{ fontSize: "large", color: "#ff0000" }}
            //     type="close-circle"
            //   />
            // ) : (
            //   "Pending"
            // ),
          },
          // {
          //   title: "Caricato il",
          //   dataIndex: "caricato_il",
          //   key: "caricato_il",
          //   width: "10%",
          //   ellipsis: true,
          //   render: (text) => moment(text).format("DD/MM/YY HH:mm:ss"),
          // },
          {
            title: "Message",
            dataIndex: "message",
            key: "message",
            width: "10%",
            ellipsis: true,
            align: "center",
            render: (message) => {
              if (!message || !message.text) {
                return "-"
              }

              const content = (
                <div>
                  <p style={{ fontWeight: "bold", marginBottom: 4 }}>
                    {message.title}
                  </p>
                  <p style={{ margin: 0 }}>{message.text}</p>
                </div>
              )

              return (
                <Popover content={content} title="Message" trigger="click">
                  <Button
                    type="default"
                    size="small"
                    style={{
                      cursor: "pointer",
                      border: "1px solid #d9d9d9",
                      borderRadius: 4,
                      backgroundColor: "#fff",
                    }}
                  >
                    Read Notes
                  </Button>
                </Popover>
              )
            },
          },
        ]
      : screenWidth > 600
        ? [
            {
              title: "Eseguito il",
              dataIndex: "eseguito_il",
              key: "eseguito_il",
              ellipsis: true,
              width: "12%",
              render: (text) => moment(text).format("DD/MM/YY HH:mm:ss"),
            },
            {
              title: "DAL",
              dataIndex: "mittente",
              key: "mittente",
              ellipsis: true,
              width: "12%",
            },
            {
              title: "",
              dataIndex: "",
              key: "",
              width: "5%",
              ellipsis: true,
              align: "center",
              render: (text, record) =>
                record.metodo === "Deposito" ||
                record.metodo === "Bonifico Bancario" ? (
                  <i className="fal fa-arrow-left" style={{ fontSize: 18 }}></i>
                ) : (
                  <i className="fal fa-arrow-right" style={{ fontSize: 18 }}></i>
                ),
            },
            {
              title: "AL",
              dataIndex: "destinatario",
              key: "destinatario",
              width: "10%",
              ellipsis: true,
            },
            {
              title: "Stato",
              dataIndex: "stato",
              key: "stato",
              width: "12%",
              ellipsis: false,
              align: "center",
              filters: [
                { text: "Pending", value: "pending" },
                { text: "Accettato", value: "accepted" },
                { text: "Rifiutato", value: "rejected" },
              ],
              onFilter: (value, record) => record.stato === value,
              render: (text, record) => {
                const role = accountInfo?.profile?.role?.name

                if (
                  (role === "super_admin" || role === "main_admin") &&
                  text === "pending"
                ) {
                  return (
                    <div className="accept-refills">
                      <Select
                        placeholder="Pending"
                        style={{ width: 100 }}
                        onChange={(value) => {
                          if (value === "accept") {
                            showConfirmAccept(record.id)
                          } else {
                            showConfirmDecline(record.id)
                          }
                        }}
                      >
                        <Option value="accept">Accettato</Option>
                        <Option value="reject">Annulla</Option>
                      </Select>
                    </div>
                  )
                }

                if (text === "accepted") {
                  return forAdmin ? (
                    <Icon
                      style={{ fontSize: "large", color: "#0da90f" }}
                      type="check-circle"
                    />
                  ) : (
                    "Accettato"
                  )
                }

                if (text === "rejected") {
                  return forAdmin ? (
                    <Icon
                      style={{ fontSize: "large", color: "#ff0000" }}
                      type="close-circle"
                    />
                  ) : (
                    "Rifiutato"
                  )
                }

                return "Pending"
              },
            },
            {
              title: "Importo",
              dataIndex: "amount",
              key: "amount",
              align: "center",
              width: "10%",
              ellipsis: true,
              filters: [
                { text: "Card", value: "card" },
                { text: "Wallet", value: "wallet" },
              ],
              render: (text, record) => {
                const isPositive =
                  record.metodo === "Deposito" ||
                  record.metodo === "Bonifico Bancario"

                const iconClass = isPositive ? "fa-plus-circle" : "fa-minus-circle"
                const iconColor = isPositive ? "#0DA90F" : "#FF0000"

                console.log(record)
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      maxWidth: 120,
                      margin: "0 auto",
                    }}
                  >
                    <i
                      className={`far ${iconClass} fa-sm`}
                      style={{ color: iconColor }}
                    ></i>
                    <span>{text}€</span>
                    {record.paid_with_adyen ? (
                      <i
                        className="fa-solid fa-credit-card"
                        style={{ fontSize: 18, color: "rgb(96 165 250)" }}
                      ></i>
                    ) : record.cgn && !record.bank ? (
                      <span
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          backgroundColor: "#1958A0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: 14,
                        }}
                      >
                        €
                      </span>
                    ) : (
                      <i
                        className="fa-solid fa-money-bill-wave"
                        style={{ fontSize: 18, color: "green" }}
                      ></i>
                    )}
                  </div>
                )
              },
            },

            {
              title: "",
              dataIndex: "",
              key: "",
              width: "5%",
              align: "center",
              ellipsis: true,
              render: (text, record) => (
                <i
                  className="fal fa-eye"
                  style={{ color: "#01a81b", fontWeight: 600 }}
                ></i>
              ),
              onCell: (record) => {
                return {
                  onClick: (ev) => {
                    setShowModalResponsive(true)
                    setModalDetails(record)
                  },
                }
              },
            },
          ]
        : [
            {
              title: "Eseguito il",
              dataIndex: "eseguito_il",
              key: "eseguito_il",
              ellipsis: true,
              width: "20%",
              render: (text) => moment(text).format("DD/MM/YY HH:mm:ss"),
            },
            {
              title: "DAL",
              dataIndex: "mittente",
              key: "mittente",
              ellipsis: true,
              width: "20%",
            },
            {
              title: "",
              dataIndex: "",
              key: "",
              width: "10%",
              ellipsis: true,
              align: "center",
              render: (text, record) =>
                record.metodo === "Deposito" ||
                record.metodo === "Bonifico Bancario" ? (
                  <i className="fal fa-arrow-left" style={{ fontSize: 18 }}></i>
                ) : (
                  <i className="fal fa-arrow-right" style={{ fontSize: 18 }}></i>
                ),
            },
            {
              title: "AL",
              dataIndex: "destinatario",
              key: "destinatario",
              width: "20%",
              ellipsis: true,
              align: "center",
            },
            {
              title: "",
              dataIndex: "",
              key: "",
              width: "10%",
              align: "center",
              ellipsis: true,
              render: (text, record) => (
                <i
                  className="fal fa-eye"
                  style={{ color: "#01a81b", fontWeight: 600 }}
                ></i>
              ),
              onCell: (record) => {
                return {
                  onClick: (ev) => {
                    setShowModalResponsive(true)
                    setModalDetails(record)
                  },
                }
              },
            },
          ]

  const data =
    refills &&
    isArray(refills) &&
    refills?.map((r) => ({
      eseguito_il: r.eseguito_il,
      id: r.id,
      mittente: r.mittente,
      destinatario: r.destinatario,
      metodo: r.metodo,
      amount: r.amount,
      commissione: r.commissione,
      document: r.document,
      stato: r.stato,
      caricato_il: r.caricato_il,
      user_id: r.message?.user_id,
      message: r.message,
      paid_with_adyen: r.paid_with_adyen,
      cgn: r.cgn,
      bank: r.cgn_bank_name,
    }))

  return (
    <div
      className="Container Annunci AllTransazioni NewDepositi"
      style={{ paddingBottom: screenWidth < 500 && "100px", width: "100%" }}
    >
      {MessaggiComponent}
      <Modal
        visible={imageVisible}
        onCancel={() => {
          setImageVisible(false)
        }}
        footer={null}
        width={700}
      >
        {transferDocument.type === "image" && (
          <img
            style={{ width: "100%", marginTop: "20px" }}
            src={transferDocument.document}
            alt=""
          />
        )}
        {transferDocument.type === "application" && (
          <div>
            <iframe
              title="transferDoc"
              style={{
                width: "100%",
                marginTop: "20px",
                height: "50vh",
                overflow: "hidden",
              }}
              src={transferDocument.document}
            ></iframe>
          </div>
        )}
      </Modal>
      <div className="container-fluid overview">
        <div className="panels-container">
          {isCalendarOpen && (
            <CalendarRangePicker
              setStateFunc={(item) => {
                setPicker([item.selection])
                setFrom(moment(item.selection.startDate).format("YYYY-MM-DD"))
                setTo(moment(item.selection.endDate).format("YYYY-MM-DD"))
                setFromLabel(moment(item.selection.startDate).format("DD/MM/YYYY"))
                setToLabel(moment(item.selection.endDate).format("DD/MM/YYYY"))
              }}
              setStateFuncEmpty={() => {
                setFrom("")
                setTo("")
                setFromLabel("")
                setToLabel("")
              }}
              picker={picker}
              setCalendar={setCalendar}
              handleSubmit={handleSubmit}
            />
          )}
          <div className="sort-annunci adminAnnunci ">
            <div className="deposit-title">
              {" "}
              <h1
                className="headerTop"
                onClick={() => {
                  setFilterName("")
                  resetDates()
                  getRequestedRefills(
                    1,
                    25,
                    accountInfo?.profile?.role?.name === "super_admin"
                      ? accountInfo.profile.activity_id
                      : activeSkinId !== -1
                        ? activeSkinId
                        : null,
                  )
                }}
              >
                <Icon type="bank" />
                Depositi
              </h1>{" "}
              <div
                className="dal calendar"
                type="text"
                onClick={() => {
                  setCalendar(true)
                }}
              >
                <span>
                  {fromLabel ? `${fromLabel} - ${toLabel}` : "Seleziona la data"}
                  <i className="fal fa-calendar-alt"></i>
                </span>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                style={{ width: 200 }}
                className="search-service"
                placeholder="Cerca Utente "
                type="text"
                suffix={<Icon type="search" />}
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginLeft: 20,
                  marginTop: 11,
                }}
              >
                <ReactToPrint
                  onBeforeGetContent={() => getFullData(setIsPdfLoading)}
                  trigger={() => (
                    <Button
                      loading={isPdfLoading}
                      size="small"
                      style={{
                        border: "none",
                        display: "inline-flex",
                        alignItems: "center",
                        color: "#0078ff",
                      }}
                    >
                      <i
                        className="fal fa-file-pdf"
                        style={{
                          marginRight: "4px",
                          fontSize: "16px",
                          fontWeight: 700,
                        }}
                      />
                      .Pdf
                    </Button>
                  )}
                  content={() => componentRef.current}
                />

                <Button
                  loading={isCsvLoading}
                  size="small"
                  style={{
                    border: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#0078ff",
                  }}
                  onClick={async () => {
                    const data = await getFullData(setIsCsvLoading)
                    if (data.length > 0) {
                      setTimeout(() => csvLinkRef.current.link.click(), 100)
                    }
                  }}
                >
                  <i
                    className="far fa-file-csv"
                    style={{ marginRight: "4px", fontSize: "16px", fontWeight: 700 }}
                  />
                  .Csv
                </Button>

                <CSVLink
                  data={exportData}
                  headers={csvHeaders}
                  filename={`depositi_${moment().format("YYYYMMDD")}.csv`}
                  ref={csvLinkRef}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>
          {loadingPayments && <div className="loaderAdmin"></div>}
          {showModalResponsive === true && screenWidth <= 1024 && (
            <ModalResponsiveForTables
              Close={(e) => {
                setShowModalResponsive(false)
                setModalDetails("")
              }}
              Header={
                <React.Fragment>
                  <i className="fal fa-credit-card" aria-hidden="true"></i>
                  <span>{modalDetails.agency_name}</span>
                </React.Fragment>
              }
              beforeFooter={null}
              Footer={null}
              Rows={
                <React.Fragment>
                  <div className="OtherRow">
                    <ModalRow title="Mittente" data={modalDetails.mittente} />
                    <ModalRow
                      title="Destinatario"
                      data={modalDetails.destinatario}
                    />
                    <ModalRow
                      title="Eseguito"
                      data={moment(modalDetails.eseguito_il).format(
                        "DD/MM/YYYY HH:mm",
                      )}
                    />
                    <ModalRow
                      title="Caricato"
                      data={moment(modalDetails.caricato_il).format(
                        "DD/MM/YYYY HH:mm",
                      )}
                    />
                    <ModalRow title="Metodo" data={modalDetails.metodo} />
                    <ModalRow
                      title="Importo"
                      data={numberWithCommas(modalDetails.amount)}
                    />
                    <ModalRow
                      title="Commissione"
                      data={numberWithCommas(modalDetails.commissione)}
                    />
                    <ModalRow
                      title="Stato"
                      data={
                        modalDetails.stato === "accepted"
                          ? "Accettato"
                          : modalDetails.stato === "rejected"
                            ? "Rifiutato"
                            : "In Attesa"
                      }
                    />
                    <ModalRow
                      title="Ricevuta"
                      data={
                        modalDetails.document ? (
                          <a
                            style={{ textDecoration: "underline" }}
                            onClick={() => {
                              console.log(modalDetails)
                              getTransferDocument(modalDetails.id)
                              setImageVisible(true)
                            }}
                          >
                            Apri l'allegato
                          </a>
                        ) : (
                          "Non prevenuto"
                        )
                      }
                      // handleClick={() => getTransferDocument(modalDetails.id)}
                    />
                  </div>
                  {modalDetails.message?.title && (
                    <div className="OtherRow">
                      <ModalRow title="Title" data={modalDetails.message.title} />
                      <ModalRow title="Message" data={modalDetails.message.text} />
                      {/* <ModalRow
                        title="Status"
                        data={
                          modalDetails.message?.importance?.split("_")[1]
                            ? modalDetails.message.importance.split("_")[1] ===
                              "true"
                              ? "READ"
                              : "UNREAD"
                            : "No Record"
                        }
                      /> */}
                      <ModalRow
                        title="Sent"
                        data={moment(modalDetails.message.created_at).format(
                          "DD/MM/YYYY HH:mm",
                        )}
                      />
                      <ModalRow
                        title="Read"
                        data={moment(modalDetails.message.updated_at).format(
                          "DD/MM/YYYY HH:mm",
                        )}
                      />
                    </div>
                  )}
                </React.Fragment>
              }
            />
          )}
          {!loadingPayments && (
            <Table
              // className="table-striped-rows"
              style={{ width: "100%" }}
              columns={columns}
              pagination={false}
              showHeader={true}
              dataSource={data}
              rowKey={(record) => record.id}
              onChange={handleTableChange}
              onRow={(record) => ({
                style:
                  record.cgn && !record.bank
                    ? {
                        backgroundColor: "#DBEAFE",
                      }
                    : {},
              })}
              // onRowClick={(r) => {
              //   getRequestedRefills(
              //     1,
              //     perPage,
              //     accountInfo?.profile?.role?.name === "super_admin"
              //       ? accountInfo.profile.activity_id
              //       : activeSkinId != -1
              //       ? activeSkinId
              //       : null,
              //     from,
              //     to,
              //     r.user_id
              //   )
              // }}
            />
          )}
          <div style={{ display: "none" }}>
            <div
              ref={componentRef}
              style={{ padding: "40px", color: "#000", backgroundColor: "#fff" }}
            >
              <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
                Report Depositi
              </h2>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ borderBottom: "2px solid #000" }}>
                    {csvHeaders.map((header) => (
                      <th
                        key={header.key}
                        style={{
                          textAlign: "left",
                          padding: "8px",
                          fontSize: "12px",
                        }}
                      >
                        {header.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {exportData.map((row, index) => (
                    <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                      {csvHeaders.map((header) => (
                        <td
                          key={header.key}
                          style={{ padding: "8px", fontSize: "11px" }}
                        >
                          {/* We trim the \t for the PDF view so it looks clean */}
                          {typeof row[header.key] === "string"
                            ? row[header.key].replace("\t", "")
                            : row[header.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="paginationWrapper">
            <Pagination
              onChange={(e) => {
                getRequestedRefills(
                  e,
                  perPage,
                  accountInfo?.profile?.role?.name === "super_admin"
                    ? accountInfo.profile.activity_id
                    : activeSkinId != -1
                      ? activeSkinId
                      : null,
                  from,
                  to,
                  filterName,
                  isCard,
                )
              }}
              total={
                Object.keys(refillsPages).length === 0
                  ? 1
                  : refillsPages.total_pages * 10
              }
            />
            <Select
              defaultValue={25}
              onChange={(e) => {
                setPerPage(e)
                getRequestedRefills(
                  1,
                  e,
                  accountInfo?.profile?.role?.name === "super_admin"
                    ? accountInfo.profile.activity_id
                    : activeSkinId != -1
                      ? activeSkinId
                      : null,
                  from,
                  to,
                  filterName,
                  isCard,
                )
              }}
            >
              <Option value={10}>10 / Pagina</Option>
              <Option value={25}>25 / Pagina</Option>
              <Option value={50}>50 / Pagina</Option>
            </Select>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  screenWidth: state.main.screenWidth,
  loadingPayments: state.auth.loadingPayments,
  refills: state.auth.requestedRefills,
  refillsPages: state.auth.refillsPages,
  fromDate: state.auth.fromDate,
  accountInfo: state.auth.accountInfo,
  transferDocument: state.auth.transferDocument,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  NewDepositiAdmin,
)
